export enum PromptVersionInteractiveElementValidModels {
  gpt4o = 'gpt-4o',
  gpt4oMini = 'gpt-4o-mini',
  gpt41Mini = 'gpt-4.1-mini',
  gpt41Nano = 'gpt-4.1-nano',
  gpt41 = 'gpt-4.1',
  gpt5 = 'gpt-5',
  gpt5Mini = 'gpt-5-mini',
  gpt5Nano = 'gpt-5-nano',
  gemini25FlashLite = 'gemini-2.5-flash-lite',
  gemini25Flash = 'gemini-2.5-flash',
  gemini25Pro = 'gemini-2.5-pro',
}

export enum PromptVersionInteractiveElementValidReasoningEffort {
  none = 'none',
  minimal = 'minimal',
  low = 'low',
  medium = 'medium',
  high = 'high',
}

export enum InteractiveElementPromptType {
  soloBot = 'solo_bot',
  talkTrack = 'talk_track',
  soloModeratorBot = 'solo_moderator_bot',
  soloGraderBot = 'solo_grader_bot',
  soloRolePlayBot = 'solo_role_play_bot',
  soloTutorBot = 'solo_tutor_bot',
  soloFormCompletionBot = 'solo_form_completion_bot',
  mg1000OutlineDiscussionCleanup = 'mg_1000_outline_discussion_cleanup',
  mg1000OutlineDiscussionConceptual = 'mg_1000_outline_discussion_conceptual',
  mg1000OutlineDiscussionRoleplay = 'mg_1000_outline_discussion_roleplay',
  mg1000OutlineDiscussionScenario = 'mg_1000_outline_discussion_scenario',
  mg1000OutlineDiscussionTransmission = 'mg_1000_outline_discussion_transmission',
  mg1000OutlineRefreshExhibit = 'mg_1000_outline_refresh_exhibit',
  mg1000OutlineRefreshSegment = 'mg_1000_outline_refresh_segment',
  mg1000OutlineRefreshSlide = 'mg_1000_outline_refresh_slide',
  mg1000PreviewGenerator = 'mg_1000_preview_generator',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const InteractiveElementPromptTypeMap = {
  soloBot: InteractiveElementPromptType.soloBot,
  talkTrack: InteractiveElementPromptType.talkTrack,
  soloModeratorBot: InteractiveElementPromptType.soloModeratorBot,
  soloGraderBot: InteractiveElementPromptType.soloGraderBot,
  soloTutorBot: InteractiveElementPromptType.soloTutorBot,
  soloRolePlayBot: InteractiveElementPromptType.soloRolePlayBot,
  soloFormCompletionBot: InteractiveElementPromptType.soloFormCompletionBot,
  mg1000OutlineDiscussionCleanup:
    InteractiveElementPromptType.mg1000OutlineDiscussionCleanup,
  mg1000OutlineDiscussionConceptual:
    InteractiveElementPromptType.mg1000OutlineDiscussionConceptual,
  mg1000OutlineDiscussionRoleplay:
    InteractiveElementPromptType.mg1000OutlineDiscussionRoleplay,
  mg1000OutlineDiscussionScenario:
    InteractiveElementPromptType.mg1000OutlineDiscussionScenario,
  mg1000OutlineDiscussionTransmission:
    InteractiveElementPromptType.mg1000OutlineDiscussionTransmission,
  mg1000OutlineRefreshExhibit:
    InteractiveElementPromptType.mg1000OutlineRefreshExhibit,
  mg1000OutlineRefreshSegment:
    InteractiveElementPromptType.mg1000OutlineRefreshSegment,
  mg1000OutlineRefreshSlide:
    InteractiveElementPromptType.mg1000OutlineRefreshSlide,
  mg1000PreviewGenerator: InteractiveElementPromptType.mg1000PreviewGenerator,
}

export const InteractiveElementPromptTypeReverseMap = {
  [InteractiveElementPromptType.soloBot]: 'solo_bot',
  [InteractiveElementPromptType.talkTrack]: 'talk_track',
  [InteractiveElementPromptType.soloModeratorBot]: 'solo_moderator_bot',
  [InteractiveElementPromptType.soloGraderBot]: 'solo_grader_bot',
  [InteractiveElementPromptType.soloRolePlayBot]: 'solo_role_play_bot',
  [InteractiveElementPromptType.soloTutorBot]: 'solo_tutor_bot',
  [InteractiveElementPromptType.soloFormCompletionBot]:
    'solo_form_completion_bot',
  [InteractiveElementPromptType.mg1000OutlineDiscussionCleanup]:
    'mg_1000_outline_discussion_cleanup',
  [InteractiveElementPromptType.mg1000OutlineDiscussionConceptual]:
    'mg_1000_outline_discussion_conceptual',
  [InteractiveElementPromptType.mg1000OutlineDiscussionRoleplay]:
    'mg_1000_outline_discussion_roleplay',
  [InteractiveElementPromptType.mg1000OutlineDiscussionScenario]:
    'mg_1000_outline_discussion_scenario',
  [InteractiveElementPromptType.mg1000OutlineDiscussionTransmission]:
    'mg_1000_outline_discussion_transmission',
  [InteractiveElementPromptType.mg1000OutlineRefreshExhibit]:
    'mg_1000_outline_refresh_exhibit',
  [InteractiveElementPromptType.mg1000OutlineRefreshSegment]:
    'mg_1000_outline_refresh_segment',
  [InteractiveElementPromptType.mg1000OutlineRefreshSlide]:
    'mg_1000_outline_refresh_slide',
  [InteractiveElementPromptType.mg1000PreviewGenerator]:
    'mg_1000_preview_generator',
}

export const InteractiveElementPromptTypeList = [
  InteractiveElementPromptType.soloBot,
  InteractiveElementPromptType.talkTrack,
  InteractiveElementPromptType.soloModeratorBot,
  InteractiveElementPromptType.soloGraderBot,
  InteractiveElementPromptType.soloTutorBot,
  InteractiveElementPromptType.soloRolePlayBot,
  InteractiveElementPromptType.soloFormCompletionBot,
  InteractiveElementPromptType.mg1000OutlineDiscussionCleanup,
  InteractiveElementPromptType.mg1000OutlineDiscussionConceptual,
  InteractiveElementPromptType.mg1000OutlineDiscussionRoleplay,
  InteractiveElementPromptType.mg1000OutlineDiscussionScenario,
  InteractiveElementPromptType.mg1000OutlineDiscussionTransmission,
  InteractiveElementPromptType.mg1000OutlineRefreshExhibit,
  InteractiveElementPromptType.mg1000OutlineRefreshSegment,
  InteractiveElementPromptType.mg1000OutlineRefreshSlide,
  InteractiveElementPromptType.mg1000PreviewGenerator,
]

export const InteractiveElementPromptTypeNames = Object.keys(
  InteractiveElementPromptTypeMap
)
